
import React from "react";
import { UserX } from "lucide-react";

const EmptyUserList = ({ message = "No users found" }) => {
  return (
    <div className="text-center py-8">
      <UserX className="h-12 w-12 mx-auto text-muted-foreground" />
      <p className="mt-2 text-muted-foreground">{message}</p>
    </div>
  );
};

export default EmptyUserList;
